const constructRawVideoURL = (video, token) => {
  const { tree_id: treeId, photo_id: photoId, one } = video

  return `/${treeId}/${photoId}/${token}/video_medium${one}-video.mp4`
}

export default constructRawVideoURL
